import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Img, Button } from "arv-reactcomponents";
import Anchor from "../../Anchor";
import { ORDERDETAILS, HIDE_BRANDNAME, pageType, Endpoints } from "npmlinks-constants";
import { ToCurrency } from "../../../utils";

const {
  RETURN_ELIGIBLE,
  CANCEL_ELIGIBLE,
} = ORDERDETAILS;

const isDiscountedItem = (mrp, discountedAmount) => mrp > discountedAmount;

@inject("ProductStore")
@observer
class ConsignmentImage extends Component {
  static historyState(link) {
    return {
      pathname: link,
      state: {
        currentPage: pageType.pdp,
      },
    };
  }
  constructor(props) {
    super(props);
    const { item: { product } } = props;
    const { image = "" } = product;
    this.state = {
      mainImage: image,
    };
    this.returnType = this.returnType.bind(this);
    this.onReturnClick = this.onReturnClick.bind(this);
    this.onMainImageError = this.onMainImageError.bind(this);
    this.onProductClick = this.onProductClick.bind(this);
  };
  returnType(eligibleForReturn, eligibleForCancellation) {
    const returns = (eligibleForReturn && RETURN_ELIGIBLE) || "";
    const cancel = (eligibleForCancellation && CANCEL_ELIGIBLE) || "";
    const type = returns || cancel || "";
    const returnClass = type ? "" : "nwc-hide";
    return {
      returnType: type,
      returnClass,
    };
  }
  onReturnClick(event, itemId, addressId, returnType) {
    event.preventDefault();
    this.props.returnClick(itemId, addressId, returnType);
  }


  onMainImageError() {
    this.setState({ mainImage: Endpoints.noImg});
  }
  get mainImage() {
    const { mainImage } = this.state;
    return (mainImage || Endpoints.noImg);
  }

  onProductClick() {
    const { url: link, product } = this.props.item;
    const {
      brand,
      description,
      styleId,
      image,
    } = product;
    const obj = {
      mainStyle: {
        link,
        brandName: brand,
        name: description,
        styleId,
        images: [{ medium: image }],
      },
    };
    this.props.ProductStore.setPdpData(obj);
  }

  strikeMrp(mrp, discountedPrice) {
    return (<span><s>{ToCurrency(mrp)}</s>{'  '}{ ToCurrency(discountedPrice)}</span>);
  }

  render() {
    const { item, key, addressId } = this.props;
    const {
      product,
      itemId,
      eligibleForReturn,
      eligibleForCancellation,
      url,
      discountedPrice,
    } = item;
    const { image, brand, description, mrp, color, size } = product;
    const { returnType, returnClass } = this.returnType(
      eligibleForReturn,
      eligibleForCancellation,
    );
    return (
      <Anchor.component
        href={url}
        to={ConsignmentImage.historyState(url)}
        className="nw-consignment-carousel-item"
        onClick={this.onProductClick}
        key={key}
      >
        <Img
          className="nw-consignment-image"
          src={this.mainImage}
          onError={this.onMainImageError}
        />
        <div className="nw-consignment-product-description">
          {!HIDE_BRANDNAME && (
            <div className="nw-consignment-brandtxt">{brand}</div>
          )}
          <div className="nw-consignment-name">{description}</div>
          <div className="nw-consignment-price">
          {isDiscountedItem(mrp, discountedPrice) ? this.strikeMrp(mrp, discountedPrice) :ToCurrency(mrp)}
          </div>
          <div className="nw-consignment-skudata">
            {color} | {size}
          </div>
          <Button
            className={`nw-consignment-cancel ${returnClass}`}
            onClick={(event) => this.onReturnClick(event, itemId, addressId, returnType)}
          >
            {returnType}
          </Button>
        </div>
      </Anchor.component>
    )
  }
}


ConsignmentImage.defaultProps = {
  item: [],
};

ConsignmentImage.wrappedComponent.propTypes = {
  item: PropTypes.arrayOf(PropTypes.object),
  returnClick: PropTypes.func.isRequired,
  addressId: PropTypes.string.isRequired,
  key: PropTypes.number.isRequired,
  ProductStore: PropTypes.shape({
    setPdpData: PropTypes.func.isRequired,
  })
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentImage,
  component: ConsignmentImage,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/ConsignmentImage/index.js